import { Dispatch, SetStateAction } from 'react';
import { OrganisationToggleEnum } from '../userManagement.type';
import { GetUsersResponse } from '@inplay/models';
import { AddMenuOption } from '../userManagementHelper';

export enum VenuesViewTableHeaderKey {
  ORG_NAME = 'Organisation Name',
  SUB_ORG_NAME = 'Sub-Organisation Name',
  VENUE_NAME = 'Venue Name',
  VENUE_BRANCH_NAME = 'Venue Branch Name',
  STATUS = 'Status',
  ACTIVE_USERS = 'Total Active Users',
  INACTIVE_USERS = 'Total Inactive Users',
  SUB_ORGS = 'Total Sub-Organisations',
  VENUES = 'Total Venues',
  VENUE_BRANCHES = 'Total Venue Branches',
  ADDED_BY = 'Added By',
}

export enum OrganizationUnitKey {
  NAME = 'name',
  STATUS = 'status',
}

export enum VenuesViewKebabOptions {
  EDIT_ORG = 'Edit organisation',
  DELETE_SUB_ORG = 'Delete sub-organisation',
  EDIT_SUB_ORG = 'Edit sub-organisation',
  DELETE_VENUE = 'Delete venue',
  EDIT_VENUE = 'Edit venue',
  EDIT_VENUE_BRANCH = 'Edit venue branch',
  DELETE_VENUE_BRANCH = 'Delete venue branch',
}

export enum VenuesViewAddOptions {
  ADD_SUB_ORGANISATION = 'Add sub-organisation',
  ADD_VENUE = 'Add venue',
  ADD_VENUE_BRANCH = 'Add venue branch',
  ADD_USER = 'Add user',
}

export type VenuesViewProps = {
  query: string;
  selectedOrganisationToggle: OrganisationToggleEnum;
  setSelectedOrganisationToggle: Dispatch<
    SetStateAction<OrganisationToggleEnum>
  >;
  handleSearchChange: (query: string) => void;
  handleAddUser: (action: AddMenuOption) => void;
  usersList: GetUsersResponse[];
};

export enum VenuesViewSearchParams {
  NESTED_LEVEL = 'nestedLevel',
  SELECTED_ORG_UNIT_IDS = 'selectedOrgUnitIds',
  SHOW_USERS = 'showUsers',
}

export type AddOrganisationModalProps = {
  show: boolean;
  onToggle: (val: boolean) => void;
  type: VenuesViewAddOptions;
  onSuccess?: () => void;
};

export type AddOrganizationUnitResponse = {
  data: {
    organizationUnitId: string;
  };
  statusCode: number;
  status: string;
  message: string;
};

export enum AddOrganizationUnitResponseStatus {
  SUCCESS = 201,
}

export enum ViewByOption {
  SUB_ORGANIZATION_WITH_NO_USER = 'nousers',
  SUB_ORGANIZATION_WITH_INACTIVE_USER = 'inactiveusers',
  SUB_ORGANIZATION_WITH_NO_ACTIVE_USER = 'noactiveuser',
}

export enum StatusOption {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
